import { MailboxType } from 'owa-client-ids';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
function isIRM(item) {
    return item.RightsManagementLicenseData != null;
}
function isSMIME(itemClass) {
    return (itemClass.indexOf('ipm.note.smime') == 0 &&
        itemClass.indexOf('ipm.note.smime.multipartsigned') == -1);
}
function isReport(itemClass) {
    return itemClass.indexOf('report') == 0;
}
export default function itemSupportsAddins(item) {
    if (isIRM(item)) {
        return false;
    }
    else if (item.IsDraft) {
        return false;
    }
    else if (isMailFeatureEnabled('grp') && item.MailboxInfo.type === MailboxType.GroupMailbox) {
        return false;
    }
    else {
        var itemClass = item.ItemClass.toLowerCase();
        if (isSMIME(itemClass) || isReport(itemClass)) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=ItemSupportsAddins.js.map